import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import { SessionContext } from "../context/session-context";

import CloseButton from '../assets/icons/CloseButton.gif';
import ToggleButton from "@material-ui/lab/ToggleButton";
//import getLayersInformation from "../functions/getAdditionalDisplayLayers";

export default function LayerInformationCard(props) {

  const useStyles = makeStyles(() => ({
    root: {
        position: 'absolute',
        top: 145,
        display:props.display,
        left: props.hasLeftPanel ? props.leftPanelWidth + 45 : 65,
        padding: 0,
        zIndex:10
    },
    inner: {
      background: '#fff',
      minWidth:500,
      maxWidth:500,
      paddingBottom: 20,
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: 4,
    },
    layerList: {
      margin: 0,
      padding: '0 10px',
      listStyleType: 'none'
    },
    layerListItem: {
      margin: '5px 0',
    },
    listItemButton: {
      fontSize: 10,
      color: '#000000',
      padding: 5,
      border: '1px solid rgba(0, 0, 0, 0.12)',
      width: '100%',

      '&:hover': {
        backgroundColor: '#0C4C35',
        color: '#FFFFFF',
      },
      '&.MuiToggleButton-root.Mui-selected': {
        backgroundColor: '#0C4C35',
        color: '#FFFFFF',
      },
    },
    textItemFont:{
      fontSize:10
    },
    itemAttributes:{
      margin: 5,
    },
    itemLabel:{
      color: '#000',
      marginRight: 10,
      display: 'inline-block'
    },
    itemText:{
      color: '#000',
      marginRight: 10,
      display: 'inline-block',

      '& a': {
        color: '#0C4C35'
      }
    },
    itemTextEmphasis:{
      color: '#000',
      fontWeight: 'bold',
      marginRight: 10,
      display: 'inline-block',

      '& a': {
        color: '#0C4C35'
      }
    },
    closeButton:{
      backgroundColor: '#FFF',
      backgroundImage: `url(${CloseButton})`,
      backgroundRepeat: 'no-repeat',  
      backgroundPosition: 'center',     
      width: 16,
      height: 16,
      minWidth: 20,
      padding: 0,
      margin: '5px 3px',
    }
  }));

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [item, setItem] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (sState.layerInformation.length > 0){
      setSelected(0);

      // Force selected to be shown in the popup
      // NOTE: useEffect doesn't always get triggered here
      //       ... (maybe when layer doesn't change?)
      showSelected();
    }
    else {
      // No results, hide panel
      handlePaperClose();
    }
  },[sState.layerInformation]);

  useEffect(() => {
    showSelected();
  },[selected]);

  const showSelected = () => {
    if (sState.layerInformation[selected] !== undefined) {
      let laye = sState.layerInformation[selected];

      const itemObj = [];
      for (let o in laye) {
        if (o !== 'layer' && o !== 'label'){
          const j = {};
          j.label = o;
          //j.value = laye[o];
          j.value = laye[o] ? laye[o] : "";
          itemObj.push(j);
        }
      }
      setItem(itemObj);
    }
  };
  
  const handlePaperClose = () => {
    setItem([]);
    sDispatch({ type: "setUserAction", payload: { action: 'hidelayerinformation' } });
  };

  return (
    <div className={classes.root}>
      <Box className={classes.inner}>
        <Box display="flex">
          <Box flexGrow={1} display="flex" justifyContent="right"><Button className={classes.closeButton} onClick={handlePaperClose}></Button></Box>
        </Box>
        <Grid container key={'cols'}>
          <Grid item xs={4}>
            <ul className={classes.layerList}>
              {sState.layerInformation.map((item, i) =>
                  <li className={classes.layerListItem} key={i}>
                    <ToggleButton value={item.layer} className={classes.listItemButton} selected={i == selected} onClick={e => setSelected(i)}>
                      <Box>{item.label}</Box>
                    </ToggleButton>
                  </li>
              )}
            </ul>
          </Grid>
          <Grid item xs={8}>
            <Box className={classes.itemAttributes} >
              {item.map((item, i) =>
                  <Grid container key={i}>
                    <Grid item xs={4}>
                      <Box className={classes.itemLabel} flexWrap="nowrap" fontWeight="fontWeightBold" fontSize={11}>{item.label}</Box>
                    </Grid>
                    <Grid item xs={8}>
                      <Box className={['Name', 'Probability', 'Class'].includes(item.label) ? classes.itemTextEmphasis : classes.itemText} flexWrap="nowrap" fontSize={11}>{item.value.includes('://') ? <a href={item.value} target={'_blank'}>{item.value.split('/')[2]}</a> : item.value}</Box>
                    </Grid>
                  </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}